<div class="alert-error col-md-12">
  <app-alert-error></app-alert-error>
</div>
<div class="customer-profile-form-container" id="customer-profile-form-container" *ngIf="!showLoading">
  <form [formGroup]="customerProfileFormGroup">
    <div class="customer-profile-form" id="customer-profile-form" *ngIf="showSendCode">

      <div id="customer-profile-heading">
        <h2>{{cfetLabels.cfet_customer_profile.sub_heading}}</h2>
      </div>

      <div id="customer-profile-desc">
        <div id="profile-decs1">
          <p *ngIf="showNumberSection">
            {{cfetLabels.cfet_customer_profile.profile_decs1}}<br>{{cfetLabels.cfet_customer_profile.profile_decs3}}
          </p>
          <p *ngIf="showEmailSection">
            {{cfetLabels.cfet_customer_profile.profile_decs1}}<br>{{cfetLabels.cfet_customer_profile.profile_decs4}}
          </p>
        </div>
        <div id="profile-decs2" *ngIf="hideStaticText">
          <p><em>{{cfetLabels.cfet_customer_profile.profile_des2}}</em></p>
        </div>
      </div>

      <div id="profile-number-section" *ngIf="showNumberSection">
        <label for="mobile-number-label"
          id="mobile-number-label">{{cfetLabels.cfet_customer_profile.number_text}}</label>
        <h2 id="wireless-number">{{cfetLabels.cfet_customer_profile.number}}{{wirelessNumber}}</h2>
        <a id="email-link" tabindex="0" (click)="showEmail($event)"
          (keyup)="showEmail($event)">{{cfetLabels.cfet_customer_profile.use_email}}</a>
      </div>

      <div id="profile-email-section" *ngIf="showEmailSection">
        <label for="email-id-label" id="email-id-label">{{cfetLabels.cfet_customer_profile.email_add}}</label>
        <h2 id="email-id">{{cfetLabels.cfet_customer_profile.email}}{{emailAddress}}</h2>
        <a id="number-link" tabindex="0" (click)="showNumber($event)"
          (keyup)="showNumber($event)">{{cfetLabels.cfet_customer_profile.use_mobile}}</a>
      </div>

      <div id="profile-footer-column">
        <div class="button-send-code">
          <button type="button" id="btn-send" (click)="sendCode($event)" (keyup)="sendCode($event)"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetLabels.cfet_customer_profile.send_code}}</button>
        </div>
        <div class="cancel-link-section">
          <a id="link-cancel" tabindex="0" (click)="cancel($event)"
            (keyup)="cancel($event)">{{cfetLabels.cfet_customer_profile.cancel}}</a>
        </div>
      </div>

      <div id="important-message-section">
        <p id="important"><strong>{{cfetLabels.cfet_customer_profile.important}}</strong></p>
        <p id="imp-desc">{{cfetLabels.cfet_customer_profile.imp_desc}}</p>
      </div>

    </div>

    <div class="customer-profile-code" id="customer-profile-code" *ngIf="showCodeVerification">

      <div id="customer-profile-heading1">
        <h2>{{cfetLabels.cfet_customer_profile.sub_heading1}}</h2>
      </div>

      <div id="code-sent-to">
        <label for="code-sent-label" id="code-sent-label">{{cfetLabels.cfet_customer_profile.enter_code}}</label>
        <p id="code-number" *ngIf="displayUsedNumber">{{cfetLabels.cfet_customer_profile.number}}{{wirelessNumber}}</p>
        <p id="code-number" *ngIf="displayUsedEmail">{{cfetLabels.cfet_customer_profile.email}}{{emailAddress}}</p>
      </div>

      <div id="expires-in">
        <label for="time-label" id="time-label">{{cfetLabels.cfet_customer_profile.expires_in}}</label>
        <p id="timer-count">{{minutes}}:{{seconds}}</p>
      </div>

      <div class="row form-row" id="input-code" [class.error]="securityCodeError || timeExpired">
        <input id="received-code" class="received-code" name="code" tabindex="0" maxlength="256" autocomplete="off"
          type="text" formControlName="securityCode" aria-label="Activation OTP" [class.error]="securityCodeError"
          (blur)="checkOTP()">
        <div *ngIf="timeExpired" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (timeExpired)}">
          <em class="icon-badgealert" aria-hidden="true"></em>
          <span *ngIf="timeExpired" [innerHTML]="cfetMessages.otp_code_expired"></span>
        </div>
      </div>

      <div id="resend-link-section">
        <div id="resend-link">
          <a id="link-resend" tabindex="0" (click)="resendCode($event)"
            (keyup)="resendCode($event)">{{cfetLabels.cfet_customer_profile.resend_code}}</a>
        </div>
        <div id="use-email">
          <a id="link-use-email" *ngIf="useEmailInstead" tabindex="0" (click)="useEmail($event)"
            (keyup)="useEmail($event)">{{cfetLabels.cfet_customer_profile.email_instead}}</a>
          <a id="link-use-email" *ngIf="useNumberInstead" tabindex="0" (click)="useNumber($event)"
            (keyup)="useNumber($event)">{{cfetLabels.cfet_customer_profile.number_instead}}</a>
        </div>
      </div>

      <div id="profile-footer-column">
        <div class="button-send-code">
          <button type="button" id="btn-send" (click)="submit($event)" (keyup)="submit($event)"
            class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledSubmitButton()"><em aria-label=""></em>
            {{cfetLabels.cfet_customer_profile.submit}}</button>
        </div>
        <div class="cancel-link-section">
          <a id="link-cancel" tabindex="0" (click)="cancelSubmit($event)"
            (keyup)="cancelSubmit($event)">{{cfetLabels.cfet_customer_profile.cancel}}</a>
        </div>
      </div>
    </div>
  </form>

  <div [ngClass]="showInactivityModal ? 'open-inactivity-modal' : ''">
    <app-customer-inactivity-modal [openModal]="openInactivityModal"
      (closeInactivityModal)="closeInactivityModal($event)">
    </app-customer-inactivity-modal>
  </div>
</div>

<div id="customer-complete-profile-confirmation-container" *ngIf="showCompleteProfileSection">
  <div id="customer-complete-profile-confirmation">
    <app-complete-profile-confirmation></app-complete-profile-confirmation>
  </div>
</div>

<div [ngClass]="showCancelModal ? 'open-cancel-modal' : 'hide-cancel-modal'">
  <app-customer-cancel-modal [openModal]="openCancelModal" (closeCancelModal)="closeCancelModal($event)">
  </app-customer-cancel-modal>
</div>

<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>